import { render, staticRenderFns } from "./AvaliacaoForm.vue?vue&type=template&id=495ddbe5&scoped=true"
import script from "./AvaliacaoForm.vue?vue&type=script&lang=js"
export * from "./AvaliacaoForm.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoForm.vue?vue&type=style&index=0&id=495ddbe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ddbe5",
  null
  
)

export default component.exports